import styled, { css } from 'styled-components';
import { Typography } from '../Typography';
import { FlexCenterAligned, FlexibleDiv } from '../../../styled/common';
import { Breakpoints } from '../../../styled/constants';

export const modalStyles = css`
  height: max-content;
  width: calc(100% - 30px);
  border-radius: 14px;

  @media (min-width: ${Breakpoints.tablet}px) {
    width: 445px;
    height: max-content;
  }
`;

export const IconContainer = styled(FlexCenterAligned)`
  margin-bottom: 10px;
`;

export const PopupContent = styled.div`
  padding: 25px 20px 20px;
  height: 100%;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 40px 50px;
  }
`;

export const PopupTitle = styled(Typography)`
  display: block;
  text-align: center;
  margin-bottom: 10px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 20px;
  }
`;

export const PopupMessage = styled(Typography)`
  display: block;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 20px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 30px;
  }
`;

export const ButtonsContainer = styled(FlexibleDiv)<{ $withReverse: boolean }>`
  gap: 10px;

  ${({ $withReverse }) =>
    $withReverse &&
    css`
      flex-direction: row-reverse;
    `};
`;

export const buttonStyles = css`
  > span {
    border: none;
  }
`;
